import { useEffect, useState } from 'react';

import { servGetmetricasV2 } from '../../servicos/metrica';
import { toastErrorPydantic } from '../../util/toast_pydantic';

function SelectMetricaIndicadorControlled({ id, value, onChange }) {

    const [metricas, setMetricas] = useState([])

    useEffect(() => {
        getMetricas()
    }, []);

    const getMetricas = async () => {
        try {
            const metricasDaApi = await servGetmetricasV2()
            setMetricas(metricasDaApi)
        } catch (erro) {
            toastErrorPydantic(erro)
        }
    }

    return (
        <>
            {metricas ? (
                <div className="">
                    <select
                        className="form-select"
                        id={id}
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value || null)}
                    >
                        <option value="">Selecione uma opção</option>
                        {metricas.map((metrica) => (
                            <option key={metrica.codigo} value={metrica.codigo}>
                                {metrica.codigo} - {metrica.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <>
                    <p>Carregando informações dos Indicadores...</p>
                </>
            )}
        </>
    )
}

export default SelectMetricaIndicadorControlled